const hasMeetingType = (type, meetingTypes) => {
  return meetingTypes.some(meetingType => meetingType.type === type)
}

export default hasMeetingType
